<template>
  <div class="love_box">
    <div class="love">
      <div class="title">爱心捐赠</div>
      <div class="love_bottom">
        <div class="amount">
          <div>捐赠总额</div>
          <div>{{amount}}</div>
          <div>元</div>
        </div>
        <div class="count">
          <div>捐赠人次</div>
          <div>{{count}}</div>
          <div>人次</div>
        </div>
      </div>
    </div>
    <div class="information-right">
      <i></i>
      <div class="information-right-header clearfix">
        <i></i>
        <p class="p1 clearfix">
          <img src="../../assets/images/taoyuan/love.png" align="center" />
          <span>爱心捐赠</span>
        </p>
        <!-- <div class="more">更多></div> -->
      </div>
      <div class="information-right-bottom clearfix">
        <div class="main">
          <vue-seamless-scroll :data="donationList" class="seamless-warp">
            <ul id="ul">
              <li v-for="(item) in donationList" :key="item.id">
                <i></i>
                <p :title="item.pub_name||item.name">{{item.pub_name||item.name}}</p>
                <span>￥{{item.money}}</span>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      donationList: [],
      amount: "",
      count: ""
    };
  },
  methods: {
    //数字格式化(每三位加逗号)
    toThousands(num) {
      var num = (num || 0).toString(),
        result = "";
      while (num.length > 3) {
        result = "," + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
      }
      if (num) {
        result = num + result;
      }
      return result;
    }
  },
  mounted() {
    this.$db.get(this.$url.donation.list + "?page_size=100").then(res => {
      this.donationList = res.data.data;
    }).catch(err => {
            console.log(err);
          });
    this.$db.get(this.$url.donation.index).then(res => {
      if (res.code == 200) {
        this.amount = this.toThousands(Math.round(res.data.donation_sum));
        this.count = this.toThousands(res.data.donation_count);
      }
    }).catch(err => {
            console.log(err);
          });
  }
};
</script>
<style lang="less" scoped>
.love_box {
  > .love {
    width: 280px;
    height: 140px;
    margin-left: 20px;
    margin-bottom: 20px;
    background: url("../../assets/images/taoyuan/donation.png") no-repeat;
    overflow: hidden;
    margin: 0 auto;
    .title {
      margin: 16px 0 20px;
      color: #ec8014;
      font-size: 18px;
      text-align: center;
      font-weight: 550;
      font-family: myFont;
    }
    .love_bottom {
      color: #fff;
      padding: 0 30px;
      .amount,
      .count {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        font-family: myFont;
        color: #ec8014;
        div:nth-of-type(2) {
          font-size: 20px;
          line-height: 14px;
          font-family: myFont;
        }
      }
    }
  }
  > .information-right {
    margin: 0 auto;
    height: 310px;
    width: 280px;
    box-sizing: border-box;
    border: solid 1px #e5e5e5;
    padding: 0 16px;
    position: relative;
    overflow: hidden;
    > i {
      width: 100%;
      height: 1px;
      background-color: #ccc;
      position: absolute;
      left: 0;
      top: 50px;
    }
    > .information-right-header {
      position: relative;
      z-index: 9999;
      height: 50px;
      > i {
        width: 110px;
        height: 2px;
        position: absolute;
        left: 0;
        top: 0;
      }
      > .p1 {
        float: left;
        font-size: 20px;
        font-family: MicrosoftYaHei-Bold;
        margin: 0;
        font-weight: 700;
        line-height: 50px;
        > span {
          color: #ec8014;
        }
      }
      > .p2 {
        float: right;
        color: #ccc;
        cursor: pointer;
        font-size: 14px;
        margin: 0;
        line-height: 50px;
      }
      .more {
        cursor: pointer;
        color: #888;
        font-size: 14px;
        height: 50px;
        line-height: 50px;
        float: right;
      }
    }
    > .information-right-bottom {
      width: 100%;
      overflow: hidden;
      > .main {
        width: 100%;
        height: 100%;
        float: left;
        overflow: hidden;
        > .seamless-warp {
          height: 100%;
          overflow: hidden;
        }
        ul {
          width: 100%;
          height: 200%;
          list-style-type: none;
          padding-left: 0;
          margin: 0;
          overflow: hidden;
        }
        ul li {
          font-size: 16px;
          color: #404040;
          // overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          position: relative;
          height: 38px;
          line-height: 38px;
          box-sizing: border-box;
          > i {
            width: 100%;
            height: 1px;
            background-color: #ccc;
            position: absolute;
            left: 0;
            bottom: 1px;
          }

          > p {
            float: left;
            margin: 0;
            color: #404040;
            width: 70%;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          > span {
            float: right;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/donation/list3.vue